<template lang="pug">
#app(NOTdragover.prevent="readingListOpen = true",
     :class="{ hasModal }",
     @drop.prevent="dropBefore = null")
  .loader(v-if="forceLoader || loader")
    .multi-ripple(v-for="i in Array.from(new Array(20), (item, i) => i)",
                  :nudge="i",
                  :style="{ 'margin-top': random(4) + 'rem', 'margin-left': random(4) + 'rem' }")
  #bp
  headr(v-if="doco || robo")
  cheatsheet-header(v-else)
  strip(v-if="!cheatsheetLP")
  clipboardImages
  highResClipboardImages
  //.tag-cloud(:class="{ cloud }")
  //  vue-word-cloud(:words="Object.entries(insightTagsFiltered)",
  //                 :animationDuration="0",
  //                 :color="color"
  //                 :rotation="rotation"
  //                 font-family="Roboto")
  //    template(slot-scope="{ word, text, weight }")
  //      .word(style="cursor: pointer;", :title="weight", @click="tag(word)") {{ text }}
  //-cheatsheet(v-if="hasCheatsheet || cheatsheetLP")
  //-cheatsheet(v-if="cheatsheetLP")
  notifications(group="tb", position="top center")
  .clear-clipboard(@mousedown="clearDown", @mouseleave="clearUp", @mouseup="clearUp", :class="{ hide: !clipboardItems.length }") hold to
    .count {{ clipboardItems.length }}
    |  deselect item
    .s {{ clipboardItems.length > 1 && 's' || '' }}&nbsp;
    .delay(:style="{ width: `${ 33 * (3 - clearPressed) }%`  }")
    .copy.selected
      .paper(@click.stop.prevent="click")
        .line
        .line
        .paper
          .line
          .line
  tour(v-if="tourShown && ready", :tour="{ steps }")
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { vuexComputed } from '@/helpers';
import strip from '@/components/strip';
//import cheatsheet from '@/components/cheatsheet/index';
import headr from '@/components/topo-components/headr';
import cheatsheetHeader from '@/components/topo-components/cheatsheet-header';
import clipboardImages from '@/components/clipboard-images';
import highResClipboardImages from '@/components/high-res-clipboard-images';
//import VueWordCloud from 'vuewordcloud';
import '../node_modules/css-toggle-switch/dist/toggle-switch.css';
// import '../node_modules/vue-slider-component/lib/theme/default.scss';
let clearPressedTimer;
export default {
  name: 'app',
  data() {
    return { bp: null, height: 0, offset: 0, start: 0, end: 18, timer: null, clearPressed: 10, ready: false, steps: [] };
  },
  watch: {
    lazyLevel(newValue) {
      //console.log('wll', window.f_f_f);
      if (newValue < (window.f_f_f && 10 || 60)) {
        this.forceLoader = false;
      }
    },
    zoomed(newValue) {
      document.body.classList[newValue && 'add' || 'remove']('zoomed');
    },
    hasModal(newValue) {
      document.body.classList[newValue && 'add' || 'remove']('hasModal');
    },
    loader() {
      this.configureTour();
    }
  },
  computed: {
    ...mapGetters(['cheatsheetLP', 'dragType', 'doco', 'zoomed', 'hasModal', 'robo', 'clipboardItems', 'lazyLevel', 'engage', 'engagePlaylist', 'tourShown']),
    ...mapGetters('insightsNS', ['hasCheatsheet']),
    ...vuexComputed(
      'loader',
      'scenes',
      'filteredByTag',
      'selected',
      'shown',
      'tagCounts',
      'tags',
      'insightTagsFiltered',
      'cloud',
      'videosShown',
      'tweetsShown',
      'documentsShown',
      'bigViewerShown',
      'someTweets',
      'documents',
      'someDocuments',
      'currentVideo',
      'playlist',
      'player',
      'playing',
      'engagePlaying',
      'searchResults',
      'searchFocus',
      'query',
      'selectedToggler',
      'readingListOpen',
      'dropBefore',
      'onClipboard',
      'forceLoader',
      'engageSelectedSection',
      'engageNotificationsShown',
      'engageLinksShown',
      'collapsed',
      'engagePub',
      'engageTheme',
      'pdf',
      'tourInTourStep'
    ),
    items() {
      return this.filteredByTag || this.scenes;
    }
  },
  components: {
    headr,
    cheatsheetHeader,
    strip,
    // VueWordCloud,
    // cheatsheet,
    clipboardImages,
    highResClipboardImages,
    tour: () => import('./components/tour')
  },
  methods: {
    ...mapActions(['addLoader', 'removeLoader']),
    configureTour: function() {
      // console.log('configureTour ok', document.querySelectorAll('.key-document'));
      const { scrollX, scrollY } = window;
      // const scrollX = 0;
      // const scrollY = 0;
      /*const boxes = [...document.querySelectorAll('.key-document')].map(element => {
        const title = (element.previousSibling?.textContent || element.previousSibling?.nodeValue || '').trim().replace(/\:$/, '') || 'no title';
        const description = element.parentNode.textContent || 'no description';
        // console.log('element.parentNode', element.parentNode, description);
        const { top, left, bottom, right } = element.getBoundingClientRect();
        // const [{ top, left, bottom, right }] = element.getClientRects();
        const padding = 6;
        return {
          title,
          description,
          boxes: [
            {
              top: top + scrollY - padding,
              left: left + scrollX - padding,
              bottom: bottom + scrollY + padding,
              right: right + scrollX + padding
            }
          ]
        };
      });*/
      //console.log('getBoxes call', getBoxes('.key-document'));
      const standardPadding = 16;
      const guideWidth = 466; //make dynamic?
      this.steps = [
        {
          title: 'fund charts',
          description: 'better understand the fund',
          boxes: combine(getBoxes('.engage .stocks, .engage .fund, .engage .perf', 16)),
          styleNudge: (() => {
            const [box = {}] = combine(getBoxes('.engage .stocks, .engage .fund, .engage .perf', 36)) || [];
            const { bottom } = box;
            const r = {};
            if (bottom && window.innerWidth < 2511) {
              r.top = `${ bottom }px`;
            }
            return r;
          })()
        },
        {
          title: 'key documents',
          description: 'fact sheets, 10ks, etc. Miss nothing!',
          boxes: combine(getBoxes('.key-document', standardPadding)),
          annotations: [
            { text: 'key document', ...combine(getBoxes('.key-document:nth-of-type(1) > .bg', 0))[0], small: true },
            { text: 'page', ...combine(getBoxes('.key-document:nth-of-type(1) .page .bg', 0))[0], small: true }
          ],
          steps: [
            {
              title: 'explore key documents',
              description: 'click to continue',
              boxes: getBoxes('.key-document:first-of-type .page', standardPadding),
              open: () => {
                // this.engageNotificationsShown = true;
              },
              close: () => {
                // this.engageNotificationsShown = false;
              },
              pointer: true
            },
            {
              title: 'explore key documents',
              description: 'view and when necessary, read the fine print',
              boxes: getBoxes('.key-documents + .viewer', standardPadding),
              annotations: [
                { text: 'close', ...combine(getBoxes('.key-documents + .viewer .close', -3, 5))[0], small: true } //,
                //{ text: 'page', ...combine(getBoxes('.key-document:nth-of-type(1) .page .bg', 0))[0], small: true }
              ],
              styleNudge: (() => {
                const [box = {}] = getBoxes('.key-documents + .viewer', standardPadding) || [];
                const { top, right } = box;
                const r = {};
                if (top) {
                  r.top = `${ top * 2.5 }px`;
                }
                if (right) {
                  r.left = `${ right }px`;
                }
                return r;
              })(),
              open: () => {
                // this.engageNotificationsShown = true;
              },
              close: () => {
                this.pdf = null;
              },
              pointer: true
            }
          ]
        },
        {
          title: 'explore themes',
          description: 'focus your attention exactly where it is needed',
          boxes: getBoxes('.engage .banner > .themes-pubs > .themes-section', standardPadding, 50),
          steps: [
            {
              title: 'explore themes',
              description: 'click to continue',
              boxes: getBoxes(
                '.engage .banner .themes-pubs > .themes-section .items .item:nth-of-type(13)',
                standardPadding
              ),
              open: () => {
                this.engageTheme = null;
              },
              close: () => {
                // this.engageNotificationsShown = false;
              },
              pointer: true
            },
            {
              boxes: getBoxes('.theme-wrapper .theme', standardPadding),
              close: () => {
                this.engageTheme = null;
              }
            }
          ]
        },
        {
          title: 'holdings',
          description: 'learn more about specific assets',
          boxes: getBoxes('.engage .banner .themes-pubs > .publishers-section', standardPadding, 50),
          steps: [
            {
              title: 'explore holdings',
              description: 'click to continue',
              boxes: getBoxes('.engage .banner .themes-pubs > .publishers-section .publisher:first-of-type', standardPadding),
              open: () => {
                this.engagePub = null;
              },
              close: () => {
                // this.engageNotificationsShown = false;
              },
              pointer: true
            },
            {
              boxes: getBoxes('.scene-wrapper .scene', standardPadding),
              close: () => {
                this.engagePub = null;
                this.tourInTour = false;
                this.tourInTourStep = -1;
              }
            }
          ]
        },
        {
          title: 'sections',
          description: 'deep dive',
          boxes: getBoxes('.sections', standardPadding),
          steps: [
            {
              title: 'section viewer',
              description: 'click to continue',
              boxes: [...getBoxes('.sections .section:first-of-type', standardPadding)],
              open: async () => {
                //console.log('step open');
                //this.engageSelectedSection = this.engageSelectedSection || this.engage?.sections?.[0]?.title;
              },
              close: async () => {
                //console.log('step close');
                // todo: reset it to the prior state
                //this.engageSelectedSection = null;
              },
              pointer: true
            },
            {
              title: 'section viewer',
              description: 'the answers to questions that you are about to ask',
              boxes: [
                ...getBoxes('.section-viewer .insights', -1, -5),
                ...combine(getBoxes('.section-viewer .themes-section, .section-viewer .documents', 2, -5))
              ],
              annotations: [
                {
                  text: 'click to open in viewer',
                  ...getBoxes('.section-viewer .insights .item-wrap .item:first-of-type', -25, -200)[0],
                  position: 'bottom right',
                  small: true
                },
                {
                  text: 'filter talking points by document',
                  ...getBoxes('.section-viewer .insights-documents .documents .document:nth-of-type(2)', -25, -50)[0],
                  position: 'top right',
                  small: true
                },
                {
                  text: 'filter talking points by theme',
                  ...getBoxes('.section-viewer .insights-documents .themes-section .themes .theme:nth-of-type(4)', -25, -40)[0],
                  position: 'top right',
                  small: true
                },
                {
                  text: 'click to close',
                  ...getBoxes('.sections .section:first-of-type', -5, -40)[0],
                  position: 'top right',
                  small: true
                },
                {
                  text: 'click to switch sections',
                  ...getBoxes('.sections .section:nth-of-type(2)', -5, -40)[0],
                  position: 'top right',
                  small: true
                } //,
                //{ text: 'page', ...combine(getBoxes('.key-document:nth-of-type(1) .page .bg', 0))[0], small: true }
              ],
              open: async () => {
                console.log('step open');
                this.engageSelectedSection = this.engageSelectedSection || this.engage?.sections?.[0]?.title;
              },
              close: async () => {
                console.log('step close');
                // todo: reset it to the prior state
                this.engageSelectedSection = null;
              }
            }
          ]
        },
        {
          title: 'notifications',
          description: 'recently updated documents and videos',
          boxes: getBoxes('.header .notifications-section', 8),
          steps: [
            {
              title: 'show notifications',
              description: 'we keep an eye out so that you do not have to',
              boxes: combine(getBoxes('.header .notifications-section, .header .notifications-wrap', 8)),
              annotations: [
                { text: 'video', ...combine(getBoxes('.header .notifications-section .video:first-of-type', -standardPadding))[0], small: true, position: 'top right' },
                { text: 'document', ...combine(getBoxes('.header .notifications-section .document:first-of-type', -standardPadding))[0], small: true, position: 'top right' } //,
                //{ text: 'page', ...combine(getBoxes('.key-document:nth-of-type(1) .page .bg', 0))[0], small: true }
              ],
              styleNudge: (() => {
                const [box = {}] =
                  combine(getBoxes('.header .notifications-section, .header .notifications-wrap', standardPadding)) ||
                  [];
                const { left } = box;
                const r = {};
                if (left) {
                  // console.log('left', left);
                  r.left = `${ left - guideWidth }px`;
                }
                return r;
              })(),
              open: () => {
                this.engageNotificationsShown = true;
              },
              close: () => {
                this.engageNotificationsShown = false;
                this.tourInTourStep = -1;
              }
            }
          ]
        },
        {
          title: 'contact us',
          description: 'contact fund managers',
          boxes: getBoxes('.header .engage-links', 8, -1),
          steps: [
            {
              title: 'show contact us',
              description: 'here for you, to hear you',
              boxes: combine(getBoxes('.header .engage-links, .exit-sections', 8)),
              styleNudge: (() => {
                const [box = {}] =
                  getBoxes('.exit-sections', standardPadding) ||
                  [];
                const { left } = box;
                const r = {};
                if (left) {
                  // console.log('left', left);
                  r.left = `${ left - guideWidth }px`;
                }
                return r;
              })(),
              open: () => {
                this.engageLinksShown = true;
              },
              close: () => {
                this.engageLinksShown = false;
                this.tourInTourStep = -1;
              }
            }
          ]
        },
        {
          title: 'quick video',
          description: 'play videos to start soaking up knowledge, with all your cores',
          boxes: getBoxes('.header .engage-bap', 6),
          steps: [
            {
              title: 'picture in picture',
              description: 'listen, look, and learn',
              boxes: [...getBoxes('.header .engage-bap', 6), ...getBoxes('.player', 50)],
              force: true,
              open: () => {
                const { currentVideo, engagePlaylist } = this;
                if (!currentVideo) {
                  this.collapsed = false;
                  this.currentVideo = engagePlaylist[0];
                  this.playlist = engagePlaylist;
                }
              },
              close: () => {
                this.currentVideo = null;
              }
            }
          ]
        }
      ].filter(({ boxes, force }) => force || boxes.length);
      function combine(boxes) {
        return (
          (boxes.length && [
            {
              top: Math.min.apply(Math, pluck(boxes, 'top')),
              left: Math.min.apply(Math, pluck(boxes, 'left')),
              bottom: Math.max.apply(Math, pluck(boxes, 'bottom')),
              right: Math.max.apply(Math, pluck(boxes, 'right'))
            }
          ]) ||
          []
        );
        function pluck(items, prop) {
          return items.map(item => item[prop]);
        }
      }

      function getBoxes(selector, padding = 6, sidePadding) {
        //console.log('get boxes', selector, document.querySelectorAll(selector));
        // const { scrollX, scrollY } = window;
        return [...document.querySelectorAll(selector)].map(element => {
          // const title =
          //   (element.previousSibling?.textContent || element.previousSibling?.nodeValue || '')
          //     .trim()
          //     .replace(/\:$/, '') || 'no title';
          // const description = element.parentNode.textContent || 'no description';
          // console.log('element.parentNode', element.parentNode, description);
          const { top, left, bottom, right } = element.getBoundingClientRect();
          // const [{ top, left, bottom, right }] = element.getClientRects();
          return {
            top: top + scrollY - padding,
            left: left + scrollX - (sidePadding || padding),
            bottom: bottom + scrollY + padding,
            right: right + scrollX + (sidePadding || padding)
          };
        });
      }

      // console.log('boxes', boxes);
      /*this.steps = boxes.reduce((all, { title, description, boxes }, index) => {
        const lastOne = all[all.length - 1];
        const odd = !(index % 2);
        if (odd) {
          all.push({ title, description, boxes });
        } else if (lastOne) {
          // console.log('even', lastOne.boxes, boxes);
          lastOne.boxes = lastOne.boxes.concat(...boxes);
        }
        return all;
      }, []);*/
      // console.log('steps', this.steps);
      this.ready = true;
      setTimeout(() => this.configureTour(), 500 * Math.random() + 250);
    },
    random(max = 10) {
      return Math.round(Math.random() * max);
    },
    rotation([, weight]) {
      return (weight > 30 && 0.75) || 0;
    },
    color([, weight]) {
      return (weight > 30 && 'orange') || (weight > 10 && '#8d6e4f') || '#282828';
    },
    tag([item]) {
      this.store.dispatch('tag', { item, value: 1 });
      this.cloud = false;
    },
    clearDown() {
      this.clearPressed = 3;
      clearTimeout(clearPressedTimer);
      const decrement = () => {
        if (--this.clearPressed) {
          clearPressedTimer = setTimeout(decrement, 300);
        } else {
          this.onClipboard = {};
          setTimeout(() => (this.clearPressed = 3), 300);
        }
      };
      clearPressedTimer = setTimeout(decrement, 300);
    },
    clearUp() {
      clearTimeout(clearPressedTimer);
      setTimeout(() => (this.clearPressed = 10), 500);
    }
  },
  mounted() {
    console.log('app mounted', this.engage);
    /*
      demo todo:
      fix sentiment volume for tag cloud
      grey out dead ends for top grid
      grey out dead ends for bottom grid
      lazy load images for insights
    */
    /*const scroll = () => {
      const { videosShown, tweetsShown } = this;
      if (!videosShown && !tweetsShown) {
        this.shown = false;
        this.cloud = false;
      }
      const first = this?.$el?.querySelector('.first');
      if (first) {
        const { top: t1, height: h1 } = first.getBoundingClientRect();
        if (!this.height) {
          const third = first.nextElementSibling.nextElementSibling;
          const { height: h2 } = third.getBoundingClientRect();
          this.height = h1 + h2;
        }
        const { height } = this;
        const offset = Math.abs(t1);
        const page = Math.round(offset / height);
        const min = 6 * (page - 1);
        const start = (min > 0 && min) || 0;
        const end = 6 * (page + 3) + start - min;
        this.start = start;
        this.end = end;
      }
    };
    scroll();
    const reset = () => {
      this.height = 0;
      setTimeout(() => {
        const { shown, videosShown, tweetsShown } = this;
        scroll();
        this.shown = shown;
        this.videosShown = videosShown;
        this.tweetsShown = tweetsShown;
      }, 0);
    };
    window.addEventListener('scroll', scroll);
    window.addEventListener('resize', reset);
    window.addEventListener('orientationchange', reset);*/

    window.__defineGetter__('bpi', () => {
      return window.getComputedStyle(document.querySelector('#app > #bp')).getPropertyValue('z-index') * 1 || 1;
    });
    const bps = [0, 'desktop', 'mobile', 'small'];
    window.__defineGetter__('bp', () => bps[window.bpi]);
    // this.addLoader();
    if (this.engage) {
      console.log('app mounted scrollHeight', document.body.scrollHeight + 'px');
      this.configureTour();
    }
    (async () => {
      // const response = await fetch('https://topoqa.azurewebsites.net/api/topoqa/getdocbyid?id=z_OKfg5SMEuPjP5PnUJ0sQ');
      // this.documents = await response.json();
      // console.log(18, await this.documents, 77, this.someDocuments);
      // await this.removeLoader();
    })();
  }
};
</script>
<style lang="scss">
@import './scss/global';
body {
  &.zoomed {
    overflow: hidden;
  }
  &.hasModal {
    overflow: hidden;
  }
}
@import '~vue-slider-component/lib/theme/default.scss';
.vue-slider {
  .vue-slider-mark {
    &:first-child,
    &:last-child {
      .vue-slider-mark-step {
        display: block;
      }
    }
  }
  .vue-slider-mark-step {
    background-color: #ccc;
    visibility: visible;
    width: 12px;
    height: 12px;
    transform: translate3d(-30%, -35%, 0);
    &-active {
      background-color: $brn;
    }
  }
}
</style>
<style lang="scss">
@import './scss/global';

#app {
  font-family: Roboto, serif;
  //font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  &.zoomed {
    overflow: hidden;
  }
  &.hasModal {
    overflow: hidden;
  }
  .loader {
    /*background-color: rgba(255, 255, 255, 0.8);*/
    pointer-events: none;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 500000;
    display: grid;
    padding: 5% 20%;
    padding-left: 30%;
    grid-template-columns: repeat(6, 1fr);
    /*grid-row-gap: 1%;*/
  }

  .ripple {
    width: 2rem;
    height: 2rem;
    margin: 2rem;
    border-radius: 50%;
    border: 0.3rem solid orange;
    transform: translate(50%);
    animation: 1s ripple ease-out infinite;
  }

  @keyframes ripple {
    from {
      transform: scale(0);
      opacity: 1;
    }

    to {
      transform: scale(1);
      opacity: 0;
    }
  }
  .multi-ripple {
    $size: 6rem;
    width: 2.6rem;
    height: 2.6rem;
    margin: 2rem;
    &:first-of-type,
    &:nth-of-type(3),
    &:nth-of-type(8),
    &:nth-of-type(11),
    &:nth-of-type(13),
    &:nth-of-type(14),
    &:nth-of-type(18),
    &:last-of-type {
      margin-left: 4rem;
      margin-right: -2rem;
      &::before,
      &::after {
        $size: 3rem;
        width: $size;
        height: $size;
      }
    }
    &:nth-of-type(4),
    &:nth-of-type(12),
    &:nth-of-type(7),
    &:last-of-type {
      margin-left: -4rem;
      margin-right: 2rem;
      &::before,
      &::after {
        $size: 12rem;
        width: $size;
        height: $size;
      }
    }
    &::before,
    &::after {
      //$delay: random(2);
      position: absolute;
      content: '\00a0';
      /*content: attr(nudge);*/
      /*background-color: orange;*/
      /*background-color: rgba(255, 255, 255, 0.25);*/
      width: $size;
      height: $size;
      border-radius: 50%;
      border: 0.3rem solid orange;
      animation: 1.5s ripple infinite;
      &:nth-child(2) {
        animation-delay: 0.5s;
      }
    }
  }
  .clear-clipboard {
    cursor: pointer;
    user-select: none;
    position: fixed;
    bottom: 0.5rem;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    background-color: $brn;
    opacity: 0.65;
    padding: 0.75rem 0.5rem 0.75rem 2rem;
    z-index: 16003;
    color: white;
    font-family: Assistant, Roboto, sans-serif;
    font-size: 0.8rem;
    text-transform: uppercase;
    border-radius: 0.25rem;
    transition: all 250ms ease-in-out;
    &.hide {
      transform: translate3d(-75vw, 0, 0);
    }
    &:hover {
      opacity: 1;
    }
    & > .delay {
      position: absolute;
      top: 0.125rem;
      left: 2rem;
      height: 0.25rem;
      background-color: white;
      transition: width 300ms ease-in-out;
    }
    & > .count {
      display: inline-block;
      font-weight: 700;
      padding-left: 0.25rem;
      min-width: 0.75rem;
    }
    & > .s {
      text-align: left;
      display: inline-block;
      min-width: 0.75rem;
    }
    .copy {
      text-align: left;
      position: absolute;
      top: -1.25rem;
      left: -1rem;
      &.selected {
        .paper {
          opacity: 1 !important;
          //border-color: black;
          .line {
            //background-color: black;
            &::after {
              //background-color: black;
            }
          }
        }
      }
      .paper {
        opacity: 1;
        width: 2rem;
        height: 2.75rem;
        border: 2px solid white;
        border-radius: 3px;
        position: relative;
        top: 1rem;
        left: 1rem;
        background-color: $brn;
        transform: scale(0.4);
        transform-origin: center;
        cursor: pointer;
        > .line {
          position: absolute;
          top: 20%;
          left: 0.25rem;
          right: 0.25rem;
          height: 2px;
          background: white;
          & + .line {
            top: 60%;
          }
          &::after {
            content: '\00a0';
            position: absolute;
            top: 0.5rem;
            width: 100%;
            height: 2px;
            background: white;
          }
        }
        & > .paper {
          transform: scale(1);
          position: absolute;
          top: -0.6rem;
          left: -0.75rem;
          opacity: 1 !important;
        }
      }
    }
  }
  .clearer {
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 0.25rem;
    width: 0.6rem;
    height: 0.6rem;
    transform: translate3d(0, -50%, 0);
    background-color: white;
    border-radius: 50%;
    color: rgba($brn, 0.5);
    transition: opacity 250ms ease-in-out;
    &:hover {
      color: $brn;
    }
    &::after {
      position: absolute;
      top: 50%;
      left: 50%;
      content: '\00D7';
      transform: translate3d(-50%, -50%, 0);
    }
    &.hidden {
      opacity: 0;
      pointer-events: none;
    }
    & + input {
      box-sizing: border-box;
      padding-right: 0.8rem;
    }
  }
  NOT.tag-cloud {
    user-select: none;
    background-color: white;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    transform: translate3d(-100%, 0, 0);
    transition: transform 400ms ease-in-out;
    will-change: transform;
    &.cloud {
      transform: translate3d(0, 0, 0);
    }
    @include large {
      top: $headerHeight;
    }
    .word {
      cursor: pointer;
      transform-origin: center;
      transition: transform 200ms ease-in-out 200ms;
      will-change: transform;
      &:hover {
        transform: scale(1.2);
        //outline: 1px solid black;
      }
    }
  }
  .vue-notification-group {
    z-index: 15000;
    .vue-notification-wrapper {
      transform: translate3d(0, 5rem, 0);
      .vue-notification {
        background-color: rgba($brn, 0.8);
        color: white;
        font-size: 1rem;
        width: 30vw;
        border-left-color: rgba(black, 0.6);
      }
    }
  }
}
.magnifying-glass {
  cursor: pointer;
  position: absolute;
  bottom: 0.5rem;
  right: 0.5rem;
  font-size: 1.5rem;
  display: inline-block;
  width: 0.4em;
  box-sizing: content-box;
  height: 0.4em;
  border: 0.1em solid $brn;
  border-radius: 50%;
  opacity: 0;
  pointer-events: none;
  background-color: white;
  transition: opacity 250ms ease-in-out;
  &::before {
    content: '';
    display: inline-block;
    position: absolute;
    right: -0.25em;
    bottom: -0.1em;
    border-width: 0;
    background: $brn;
    width: 0.35em;
    height: 0.08em;
    transform: rotate(45deg);
  }
}
.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^='top'] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^='bottom'] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^='right'] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^='left'] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }

  &.info {
    $color: $brn;

    .tooltip-inner {
      background: $color;
      color: white;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, 0.1);
    }

    .tooltip-arrow {
      border-color: $color;
    }
  }

  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, 0.1);
    }

    .popover-arrow {
      border-color: $color;
    }
  }
}
</style>
